import { create } from 'zustand';
import type { SlabAnalysisRequest, SlabAnalysisType } from './types';

interface State {
  request: SlabAnalysisRequest;
  setRequest: (patch: Partial<SlabAnalysisRequest>) => void;
  setType: (t: SlabAnalysisType) => void;
  setGeometry: (patch: Partial<SlabAnalysisRequest['geometry']>) => void;
  setAutoLoads: (patch: Partial<SlabAnalysisRequest['auto_loads']>) => void;
  setOneWay: (patch: Partial<SlabAnalysisRequest['one_way']>) => void;
  setTwoWayEdges: (patch: Partial<SlabAnalysisRequest['two_way_edges']>) => void;
  loadRequest: (r: SlabAnalysisRequest) => void;
}

const defaults: SlabAnalysisRequest = {
  geometry: {
    type: 'aligerada_1d',
    Lx_m: 5.0,
    Ly_m: 0.0,
    thickness_cm: 20,
    bw_cm: 10,
    rib_spacing_cm: 40,
    t_slab_cm: 5,
  },
  auto_loads: {
    use: 'vivienda',
    acabados_kgf_m2: 100,
    tabiqueria_kgf_m2: 100,
    cielo_raso_kgf_m2: 30,
    custom_live_load_kgf_m2: null,
  },
  one_way: { support_type: 'continuous_interior' },
  two_way_edges: { bottom: 'continuo', top: 'continuo', left: 'continuo', right: 'continuo' },
  combo: 'E060',
  fc: 210,
  fy: 4200,
  cover_cm: 2.5,
};

export const useSlabAnalysisStore = create<State>((set) => ({
  request: defaults,
  setRequest: (patch) => set((s) => ({ request: { ...s.request, ...patch } })),
  setType: (t) =>
    set((s) => ({ request: { ...s.request, geometry: { ...s.request.geometry, type: t } } })),
  setGeometry: (patch) =>
    set((s) => ({ request: { ...s.request, geometry: { ...s.request.geometry, ...patch } } })),
  setAutoLoads: (patch) =>
    set((s) => ({ request: { ...s.request, auto_loads: { ...s.request.auto_loads, ...patch } } })),
  setOneWay: (patch) =>
    set((s) => ({ request: { ...s.request, one_way: { ...s.request.one_way, ...patch } } })),
  setTwoWayEdges: (patch) =>
    set((s) => ({
      request: { ...s.request, two_way_edges: { ...s.request.two_way_edges, ...patch } },
    })),
  loadRequest: (r) => set({ request: r }),
}));
